/**
 * 消息处理器接口
 * 定义消息处理的标准接口，遵循接口隔离原则
 */
export class IMessageHandler {
  /**
   * 处理消息
   * @param {MessageEvent} event - 消息事件
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {Object} callbacks - 回调函数集合
   */
  // eslint-disable-next-line no-unused-vars
  handleMessage(event, iframe, callbacks) {
    throw new Error('handleMessage method must be implemented');
  }

  /**
   * 清理资源
   */
  cleanup() {
    throw new Error('cleanup method must be implemented');
  }
}

/**
 * 消息发送器接口
 * 定义消息发送的标准接口
 */
export class IMessageSender {
  /**
   * 发送消息到iframe
   * @param {Object} messageData - 消息数据
   * @param {HTMLIFrameElement} iframe - iframe元素
   */
  // eslint-disable-next-line no-unused-vars
  sendMessageToIframe(messageData, iframe) {
    throw new Error('sendMessageToIframe method must be implemented');
  }

  /**
   * 发送初始化消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {Object} credentials - 凭证信息
   */
  // eslint-disable-next-line no-unused-vars
  sendInitMessage(iframe, credentials) {
    throw new Error('sendInitMessage method must be implemented');
  }

  /**
   * 发送登录消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {Object} credentials - 凭证信息
   */
  // 注释掉发送登录消息接口，因为不再使用 LOGIN 消息
  // sendLoginMessage(iframe, credentials) {
  //   throw new Error('sendLoginMessage method must be implemented');
  // }

  /**
   * 发送注销消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {string} reason - 注销原因
   */
  // eslint-disable-next-line no-unused-vars
  sendLogoutMessage(iframe, reason) {
    throw new Error('sendLogoutMessage method must be implemented');
  }

  /**
   * 发送切换会话消息
   * @param {HTMLIFrameElement} iframe - iframe元素
   * @param {string} conversationId - 会话ID
   * @param {string} serviceUserId - 服务用户ID
   */
  // eslint-disable-next-line no-unused-vars
  sendSwitchConversationMessage(iframe, conversationId, serviceUserId) {
    throw new Error('sendSwitchConversationMessage method must be implemented');
  }
}
